// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvestmentCountryDto
 */
export interface IInvestmentCountryDto {
    /**
     * 
     * @type {string}
     * @memberof IInvestmentCountryDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentCountryDto
     */
    alpha2?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentCountryDto
     */
    alpha3?: string;
}

/**
 * Check if a given object implements the IInvestmentCountryDto interface.
 */
export function instanceOfIInvestmentCountryDto(value: object): value is IInvestmentCountryDto {
    return true;
}

export function IInvestmentCountryDtoFromJSON(json: any): IInvestmentCountryDto {
    return IInvestmentCountryDtoFromJSONTyped(json, false);
}

export function IInvestmentCountryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentCountryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'alpha2': json['alpha2'] == null ? undefined : json['alpha2'],
        'alpha3': json['alpha3'] == null ? undefined : json['alpha3'],
    };
}

export function IInvestmentCountryDtoToJSON(json: any): IInvestmentCountryDto {
    return IInvestmentCountryDtoToJSONTyped(json, false);
}

export function IInvestmentCountryDtoToJSONTyped(value?: IInvestmentCountryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'alpha2': value['alpha2'],
        'alpha3': value['alpha3'],
    };
}

